export default "__VITE_ASSET__38c53cb4__"